import React from 'react';
import { useHistory } from 'react-router-dom';
import { useLoggedInUserStateContext } from 'context/loggedin-user-context';
import { ROUTE_URLS } from 'constants/index';
import config from 'config';
import RectangleBlockRendering from './components/RectangleBlock';
import styles from './Home.module.scss';
import apiIcon from 'images/api-icon.svg';
import createAppsIcon from 'images/create-apps.svg';
import joinIcon from 'images/JoinIcon.svg';
import guidesIcon from 'images/guides-icon.svg';
import leftSqImg from 'images/landing-page-left-square-image.png';
import devePortalTxtLogo from 'images/developer_portal.svg';
import RightSqImg from 'images/landing-page-right-square-image.png';
import logo from 'images/Paycor_APaychexCompany_HorizontalLogo-200x40.png';
import oldLogo from 'images/paycor_logo_fullcolor.svg';
import useGetMeDetails from 'features/AppCreator/hooks/useGetMeDetails';
import { useTranslation } from 'react-i18next';

const Home = () => {
	const { t } = useTranslation();
	const { data: meDetails } = useGetMeDetails();
	const { APP_CREATOR, DEV_PORTAL } = ROUTE_URLS;
	const history = useHistory();
	const state = useLoggedInUserStateContext();
	const isUserLoggedIn = Boolean(state) && Boolean(state.user);
	const { JOIN_FEATURE_FLAG, USE_NEW_LOGO_FLAG } = config;

	const showAppcreatorPage = () => {
		if (typeof meDetails === 'undefined' || meDetails === null) return false;
		if (meDetails.isPaycor || meDetails.hasEntities) return true;
		return false;
	};

	const renderTags = () => {
		if (JOIN_FEATURE_FLAG) {
			if (showAppcreatorPage() && isUserLoggedIn) {
				return (
					<RectangleBlockRendering
						alt="create-App"
						icon={createAppsIcon}
						headerName={t('create')}
						content={t('Create_and_manage_applications_and_their_access_details')}
						buttonId="btnCreateApplication"
						buttonValue={t('applications')}
						handleClick={() => history.push(APP_CREATOR.SUMMARY)}
					/>
				);
			} else {
				return (
					<RectangleBlockRendering
						alt="join"
						icon={joinIcon}
						headerName={t('join')}
						content={t('Become_part_of_our_developer_community')}
						buttonId="btnSignup"
						buttonValue={t('sign_up')}
						handleClick={() => history.push(DEV_PORTAL.JOIN_DEVELOPER_PORTAL)}
					/>
				);
			}
		}

		if (!JOIN_FEATURE_FLAG && isUserLoggedIn) {
			return (
				<RectangleBlockRendering
					alt="create-App"
					icon={createAppsIcon}
					headerName={t('create')}
					content={t('Create_and_manage_applications_and_their_access_details')}
					buttonId="btnCreateApplication"
					buttonValue={t('applications')}
					handleClick={() => history.push(APP_CREATOR.SUMMARY)}
				/>
			);
		}
	};

	return (
		<main-section>
			<top-container>
				<square-tile>
					<img src={leftSqImg} alt="left tile" />
				</square-tile>

				<middle-content>
					<center-logo>
						<img className={styles['main-logo']} alt="Paycor" title={t('paycor')} src={USE_NEW_LOGO_FLAG ? logo : oldLogo} />
						<img className={styles['develop-portal']} alt="Developer Portal" title={t('developer_portal')} src={devePortalTxtLogo} />
					</center-logo>
					<h1 className={styles['text-center']}>{t('developer_portal_description')}</h1>
				</middle-content>

				<square-tile>
					<img src={RightSqImg} alt="right tile" />
				</square-tile>
			</top-container>

			<bottom-container>
				<rectangle-row>
					<RectangleBlockRendering
						icon={apiIcon}
						alt="Api"
						headerName={t('explore')}
						content={t('Looking_for_something_Browse_our_collection_of_apis')}
						buttonId="btnBrowseApi"
						buttonValue={t('browse_apis')}
						handleClick={() => history.push(DEV_PORTAL.API_EXPLORE)}
					/>

					<RectangleBlockRendering
						icon={guidesIcon}
						alt="Guides"
						headerName={t('learn')}
						content={t('consult_our_guides_documentation_to_aid_your_development')}
						buttonId="btnViewGuides"
						buttonValue={t('view_guides')}
						handleClick={() => history.push(DEV_PORTAL.GUIDES)}
					/>

					{renderTags()}
				</rectangle-row>
			</bottom-container>
		</main-section>
	);
};

export default Home;
